/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetNewArrivalStoriesResponseCondition,
    GetNewArrivalStoriesResponseConditionFromJSON,
    GetNewArrivalStoriesResponseConditionFromJSONTyped,
    GetNewArrivalStoriesResponseConditionToJSON,
} from './GetNewArrivalStoriesResponseCondition';
import {
    NewArrivalStory,
    NewArrivalStoryFromJSON,
    NewArrivalStoryFromJSONTyped,
    NewArrivalStoryToJSON,
} from './NewArrivalStory';

/**
 * 
 * @export
 * @interface GetNewArrivalStoriesResponse
 */
export interface GetNewArrivalStoriesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetNewArrivalStoriesResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetNewArrivalStoriesResponse
     */
    num: number;
    /**
     * 
     * @type {GetNewArrivalStoriesResponseCondition}
     * @memberof GetNewArrivalStoriesResponse
     */
    condition: GetNewArrivalStoriesResponseCondition;
    /**
     * 
     * @type {Array<NewArrivalStory>}
     * @memberof GetNewArrivalStoriesResponse
     */
    data: Array<NewArrivalStory>;
}

export function GetNewArrivalStoriesResponseFromJSON(json: any): GetNewArrivalStoriesResponse {
    return GetNewArrivalStoriesResponseFromJSONTyped(json, false);
}

export function GetNewArrivalStoriesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNewArrivalStoriesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'num': json['num'],
        'condition': GetNewArrivalStoriesResponseConditionFromJSON(json['condition']),
        'data': ((json['data'] as Array<any>).map(NewArrivalStoryFromJSON)),
    };
}

export function GetNewArrivalStoriesResponseToJSON(value?: GetNewArrivalStoriesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'num': value.num,
        'condition': GetNewArrivalStoriesResponseConditionToJSON(value.condition),
        'data': ((value.data as Array<any>).map(NewArrivalStoryToJSON)),
    };
}

